import React from 'react';
import useTheme from 'branding/theme';
import useLocalization from 'localization';
const Eyebrow = ({ centered = false, type = 'regular', styles, className, children }) => {
    const { t } = useLocalization();
    const { typography } = useTheme();
    const mergedStyles = {
        ...typography.eyebrow,
        ...(centered && typography.centered),
        ...(type !== 'regular' && typography[type]),
        ...styles
    };
    return (React.createElement("div", { style: mergedStyles, className: className }, typeof children === 'string' ? t(String(children)) : children));
};
export default Eyebrow;
//# sourceMappingURL=index.js.map